/** Signals the Expo/RN shell that the React app has mounted (not just HTML). */
export function notifyNativeWebViewContentReady() {
	if (typeof window === 'undefined') return;
	if (!window.__CALCIUM_NATIVE_MOBILE || !window.ReactNativeWebView?.postMessage) return;
	try {
		window.ReactNativeWebView.postMessage('content:ready:');
	} catch {
		// ignore
	}
}
